import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { EmailToSmsPage } from 'pages/settings/pages/emailToSms/ui/emailToSmsPage'
import { EmailToSmsLayout } from 'pages/settings/pages/emailToSms/layout/EmailToSmsLayout'
import { EmailToSmsAccessLayout } from 'pages/settings/pages/emailToSms/layout/EmailToSmsAccessLayout'

export const EmailToSmsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<EmailToSmsAccessLayout />}>
        <Route element={<EmailToSmsLayout />}>
          <Route path={'/'} element={<EmailToSmsPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
